// extracted by mini-css-extract-plugin
module.exports = {"button":"GiftItemButtons_button__Jl2PI"};